var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.mainList.length > 0
    ? _c(
        "div",
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              attrs: { border: "", "show-overflow": "", data: _vm.mainList },
              on: {
                "checkbox-change": _vm.checkboxChange,
                "checkbox-all": _vm.checkboxAll,
              },
            },
            [
              _vm._l(_vm.columns, function (config) {
                return [
                  _c(
                    "vxe-table-column",
                    _vm._b(
                      {
                        key: config.id,
                        attrs: { "min-width": config.minWidth || 150 },
                      },
                      "vxe-table-column",
                      config,
                      false
                    )
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }